const appointmentTypes = ['Healthcare', 'Personal', 'Life Enrichment', 'Other']

module.exports = appointmentTypes
